// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3TwCj","validationTips":"StatementDescriptor_validationTips__2Gg0r"};